//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { LookupModel } from './../../common/models/LookupModel';
  
  export class AddMappingModel extends ModelBase {
      static readonly $typeName = 'AddMappingModel';
      public category: string;
      public vocabLookup: LookupModel;
      public submitterCode: string;
      public submittingEntityKey: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/submission/models/AddMappingModel.ts